/*
  eslint
  no-param-reassign: ["error", { "props": false }]
*/
export default {
  namespaced: true,
  state: {
    filterList: [],
  },
  mutations: {
    ADD_FILTER(state, filter) {
      state.filterList.push(filter);
    },
    REMOVE_FILTER(state, filter) {
      state.filterList = state.filterList.filter(t => t !== filter);
    },
    CLEAR_FILTER(state) {
      state.filterList = [];
    },
  },
};
